export const FINANCING_PLANS = [
  {
    title: 'Standard Plans',
    text: '<p>Best for those who want to regularly have the lowest possible monthly payment.</p>',
    description_list: [
      {
        unique_name: 'loan_period',
        name: 'Loan Period',
        value: '5',
      },
      {
        unique_name: 'down_payment',
        name: 'Down Payment',
        value: ' $0',
      },
      {
        unique_name: 'interest_rate',
        name: 'Interest Rate',
        value: '%%',
      },
      {
        unique_name: 'monthly_payment',
        name: 'Monthly Payment',
        value: '$$',
      },
    ],
  },
  {
    title: 'Zero Interest Plans',
    text: '<p>Best for those who initially want the lowest possible monthly payment.</p>',
    description_list: [
      {
        unique_name: 'loan_period',
        name: 'Loan Period',
        value: '2',
      },
      {
        unique_name: 'down_payment',
        name: 'Down Payment',
        value: '$$',
      },
      {
        unique_name: 'interest_rate',
        name: 'Interest Rate',
        value: '0%',
      },
      {
        unique_name: 'monthly_payment',
        name: 'Monthly Payment',
        value: '$$$',
      },
    ],
  },
];